import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";

export default function RankingSection() {
  const top10 = [...comics].sort((a, b) => a.ranking - b.ranking).slice(0, 10);

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2
              className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              韩国漫画排行榜
            </h2>
            <p className="text-foreground-500 text-sm">
              高分必看<strong>韩国漫画</strong>人气榜，数据每日更新
            </p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-600 hover:text-primary-700 no-underline font-medium whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {top10.slice(0, 5).map((comic, idx) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex flex-col bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:shadow-sm transition-all cursor-pointer no-underline"
            >
              <div className="relative overflow-hidden aspect-[3/4]">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 韩国漫画推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 w-7 h-7 flex items-center justify-center bg-primary-500 text-background-50 rounded-full text-xs font-bold">
                  {idx + 1}
                </span>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <span className="text-background-50 text-xs font-medium flex items-center gap-1">
                    <i className="ri-star-fill text-yellow-400 w-3.5 h-3.5 flex items-center justify-center"></i>
                    {comic.rating}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-semibold text-sm text-foreground-950 mb-1 group-hover:text-primary-700 transition-colors line-clamp-1">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-400">{comic.author}</p>
                <div className="flex gap-1.5 mt-2 flex-wrap">
                  {comic.tags.slice(0, 2).map((tag) => (
                    <span
                      key={tag}
                      className="text-xs px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 space-y-3">
          {top10.slice(5, 10).map((comic, idx) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="flex items-center gap-4 p-3 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 hover:bg-background-100/50 transition-all cursor-pointer no-underline"
            >
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 font-bold text-sm flex-shrink-0">
                {idx + 6}
              </span>
              <img
                src={comic.cover}
                alt={comic.title}
                className="w-10 h-14 rounded object-cover object-top flex-shrink-0"
              />
              <div className="flex-1 min-w-0">
                <h4 className="font-medium text-sm text-foreground-950 line-clamp-1">
                  {comic.title}
                </h4>
                <p className="text-xs text-foreground-400">{comic.author}</p>
              </div>
              <span className="text-primary-600 font-semibold text-sm whitespace-nowrap flex items-center gap-0.5">
                <i className="ri-star-fill text-yellow-400 w-3.5 h-3.5 flex items-center justify-center"></i>
                {comic.rating}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}